import React, { useMemo, useState } from "react";
import AngleLeft from "assets/icons/studentFolder/angleLeft.svg";
import AngleDown from "assets/icons/studentFolder/angleDownStudentFolderFilter.svg";
import BiddingInteractiveIcon from "assets/icons/studentFolder/biddingInerative.png";
import BidPlayIcon from "assets/icons/courses/bidPlay.png";
import "./styles.scss";

interface Props {
  data: any;
  activeLesson?: number;
  onClickExercise?: (val: any, typeClick?: "exercise" | "course") => void;
  id?: string;
}

const StudentCourseItemMobile = ({ data, activeLesson, onClickExercise, id }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const getScore = useMemo(() => {
    const winList = [];
    if (data?.exercises?.length) {
      data?.exercises?.forEach((val) => {
        if (val?.mark === 1001) {
          winList.push(val);
        }
      });
      return {
        text: `(${((winList.length / data.exercises.length) * 100).toFixed(0)}%) ${
          winList.length
        }/${data.exercises.length}`,
        percent: (winList.length / data.exercises.length) * 100
      };
    }
    return {
      text: "0/0 (0%)",
      percent: 0
    };
  }, [data?.exercises]);

  const numberRendered = useMemo(() => {
    let numberRend = 0;
    data?.exercises?.map((item) => {
      const date = new Date(item?.markUpdateDate || "");
      date.setMonth(date.getMonth() + 1);
      switch (activeLesson) {
        case 1:
          if (item?.mark === 1001) {
            if (date < new Date()) {
              //
            }
          } else {
            return null;
          }
          break;
        case 2:
          if (item?.mark === 1001) {
            if (date < new Date()) {
              //
            } else {
              return null;
            }
          } else {
            return null;
          }
          break;
        case 3:
          if (item.mark !== 1002) {
            return null;
          }
          break;
        case 4:
          if (item?.mark !== 0) {
            return null;
          }
      }
      if (activeLesson === 1) {
        if (item?.mark !== 1001) {
          return null;
        }
      }
      numberRend += 1;
    });
    return numberRend;
  }, [activeLesson, data?.exercises]);

  if (!numberRendered) {
    return null;
  }
  return (
    <div
      onClick={() => {
        setIsOpen(!isOpen);
        setTimeout(() => {
          document.getElementById(`${id}`).scrollIntoView();
        }, 200);
      }}>
      <div id={id} className="student-folder-course-wrapper">
        <div className="title-course-container">
          <span className="title-course">{data?.courseTitle}</span>
        </div>
        <div>{!!data?.interactive && !data?.bidPlay && <img src={BiddingInteractiveIcon} />}</div>
        <div>{!!data?.bidPlay && <img src={BidPlayIcon} style={{ width: 25, height: 25 }} />}</div>
        <div className="student-folder-course-container">
          <div
            className={`student-folder-course-percent-block ${
              getScore.percent < 90 ? "student-folder-course-percent-block-black" : ""
            }`}
            style={{
              backgroundImage:
                getScore.percent > 0
                  ? `linear-gradient(90deg, #1EA072 ${
                      getScore.percent
                    }%, rgba(30, 160, 114, 0.293947) ${
                      getScore.percent + 20.9
                    }%, rgba(30, 160, 114, 0) ${getScore.percent + 35.9}%)`
                  : undefined
            }}>
            <span className="student-folder-course-percent-text">{getScore.text}</span>
          </div>
          <img src={isOpen ? AngleDown : AngleLeft} />
        </div>
      </div>
      {isOpen && (
        <div className="student-folder-course-wrapper-open">
          <div className="student-folder-course-exercise-list">
            {data?.exercises?.map((item) => {
              const date = new Date(item?.markUpdateDate || "");
              date.setMonth(date.getMonth() + 1);
              let className = "";
              let isDisabled = false;
              switch (activeLesson) {
                case 1:
                  if (item?.mark === 1001) {
                    if (date < new Date()) {
                      //
                    }
                  } else {
                    return null;
                  }
                  break;
                case 2:
                  if (item?.mark === 1001) {
                    if (date < new Date()) {
                      //
                    } else {
                      return null;
                    }
                  } else {
                    return null;
                  }
                  break;
                case 3:
                  if (item.mark !== 1002) {
                    return null;
                  }
                  break;
                case 4:
                  if (item?.mark !== 0) {
                    return null;
                  }
              }
              if (!item?.filteredEx) {
                isDisabled = true;
              }
              if (activeLesson === 1) {
                if (item?.mark === 1001) {
                  // if (date < new Date()) {
                  //   return null;
                  // }
                } else {
                  return null;
                }
              }

              if (item?.mark === 1002) {
                className = "red-bg";
              } else if (item?.mark === 1001) {
                if (date < new Date()) {
                  className = "gradient-bg";
                } else {
                  className = "green-bg";
                }
              }
              return (
                <div
                  className={`student-folder-course-exercise-fon ${
                    isDisabled ? "disable-item-student-folder" : ""
                  } ${className}`}
                  key={item?.exId}
                  onClick={() =>
                    !isDisabled && onClickExercise && onClickExercise({ ...item, ...data })
                  }>
                  <div className="student-folder-course-exercise-item">
                    <span>{item?.exIndex}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentCourseItemMobile;
